import PixagriApplication from '../../models/PixagriApplications';
import {BaseApiService} from './BaseApiService';

export class BaseNotificationApiService extends BaseApiService {
  getApplication(): PixagriApplication {
    return PixagriApplication.NOTIFICATION_API;
  }
}
